/**
 * Ryan O'Dowd
 * 2024-02-12
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import CPassage from '@classes/Passage';
import PassageDisplay from '@components/PassageDisplay';
import React from 'react';

const Reading = (props: ReadingProps) => {
  return (
    <PassageDisplay
      passages={[props.passage]}// @TODO: not sure where this should live
      passageForContext={props.passage}// @TODO: why is this showing up as a tslint error? it's definitely a prop
      isPressDisabled={false}// @TODO: this needs to be true when we're panning, but i can find a way to listen to pan status
      showFormatting={true}
      showFootnotes={true}
      showHeadings={true}
      showToggleBadges={true}
      hideNumbersTextToggle={true}
      isUnattachedToGoal={true}
      showWrinkleBadges={false}
      alwaysShowSelectionMenu={true}// @TODO: would prefer this not to be true...but there's jumping when selecting otherwise
      spritzPassage={props.passage}
      footerComponent={props.finishButtonJsx}
    />
  );
};

class ReadingProps {
  // @TODO: id: number;
  passage: CPassage;
  finishButtonJsx: React.ReactNode;
};

export default Reading;
